import { useQuery } from '@tanstack/react-query';
import { api, ApiClientError } from '../api/client';
import { DashboardPage } from './DashboardPage';
import { MarketingLandingPage } from './MarketingLandingPage';

/**
 * `/` gate: logged-out visitors see the marketing landing page; signed-in users
 * (or a reachable-but-erroring API) fall through to the dashboard. Auth is
 * inferred from the shared `projects` query - a 401 means "not signed in". The
 * query key matches DashboardPage's, so react-query dedupes it (no double fetch).
 */
export function RootPage() {
  const { error, isLoading } = useQuery({
    queryKey: ['projects'],
    queryFn: () => api.listProjects(),
    retry: false,
  });

  if (isLoading) return <div className="dash-boot" aria-hidden="true" />;

  const unauthorized = error instanceof ApiClientError && error.status === 401;
  return unauthorized ? <MarketingLandingPage /> : <DashboardPage />;
}
